// work with chartjs v3.5.1, not 2.x
import React, { useState, useEffect } from 'react';
import LineChart from "./LineChart";
import axios from 'axios';
import {axiosEH} from './common/functions'
import jwtUser from '../jwtUser';

export default function Dashboard(props) {
  const [statusMsg, setStatusMsg] = useState('');
  const [profStatus, setProfStatus] = useState();   // useState({}) not work
  const [inputList, setInputList] = useState([]);  // to object?
  const user = jwtUser(); // get user token

  async function getUserDashboards() {
    const url = process.env.REACT_APP_BASEURL + '/userdash';
    axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {
        //console.log('res.data:', res.data);
        if (res.data.length) {
          // 1. 1st pop to status
          setProfStatus(res.data.pop()); 

          //2. get data for chart
          let labels = res.data.map(e => e.testID);
          let cScores = res.data.map(e => e.currentScore);
          let aScores = res.data.map(e => e.averageScore);
          let maxScores = res.data.map(e => e.maxScore);
          let minScores = res.data.map(e => e.minScore);
          setInputList([labels, cScores, aScores, maxScores, minScores])
        } else {
          setStatusMsg('No test results to show or DB issues');
        }
      })
      .catch(err => { 
        setStatusMsg(axiosEH(err)); 
      })
  }

  useEffect(() => {
    getUserDashboards();
  }, []);   // render once only

  return (
    <section >
      { profStatus && <div>
        <p style={{color:'black'}}>&nbsp;Flashcards: &nbsp; required  words {profStatus.FC[1]}, &nbsp;passed words {profStatus.FC[0]}, passed {parseInt(100*profStatus.FC[0]/profStatus.FC[1])}% </p>
        <p style={{color:'black'}}>&nbsp;Ele-school: &nbsp; required  words {profStatus.ES[1]}, &nbsp;passed words {profStatus.ES[0]}, passed {parseInt(100*profStatus.ES[0]/profStatus.ES[1])}% </p>
        <p style={{color:'black'}}>&nbsp;Mid-school: &nbsp;required  words {profStatus.MS[1]}, passed words {profStatus.MS[0]}, passed {parseInt(100*profStatus.MS[0]/profStatus.MS[1])}% </p>
        <p style={{color:'black'}}>&nbsp;Hig-school: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; required  words {profStatus.HM[1]}, passed words {profStatus.HM[0]}, passed {parseInt(100*profStatus.HM[0]/profStatus.HM[1])}% </p>
        <p style={{color:'black'}}>&nbsp;Hig-school selective: required  words {profStatus.HSM[1]}, passed words {profStatus.HSM[0]}, passed {parseInt(100*profStatus.HSM[0]/profStatus.HSM[1])}% </p>
        <LineChart labels={inputList[0]} cScores={inputList[1]}
          aScores={inputList[2]} maxScores={inputList[3]} minScores={inputList[4]} />
      </div> }
      <label className="label has-text-success">{statusMsg}</label>
      <br></br>
    </section>
  )
}